package org.ssoft.common.tools

import tk.mallumo.crypto.internal.*
import kotlin.time.Clock

@Suppress("unused")
object Authorization {
    fun createAuth(key: String): Pair<String, String> {
        val now = Clock.System.now().toEpochMilliseconds().toString()
        val pass = Crypto.encrypt("$now:${key}".encodeToByteArray()).base64Url
        return now to pass
    }
}
